import "./TermsOfService.module.css";
import Header from "@/reusable_sections/Header";
import HeroHeader from "./sections/HeroHeader";
import IntroNoticeBox from "./sections/IntroNoticeBox";
import TermsContent from "./sections/TermsContent";
import ClosingContactStrip from "./sections/ClosingContactStrip";
import Footer from "@/reusable_sections/Footer";
export default function TermsOfServicePage() {
  return <div>
      <Header />
      <HeroHeader />
      <IntroNoticeBox />
      <TermsContent />
      <ClosingContactStrip />
      <Footer />
    </div>;
}